/*
 * @Author: your name
 * @Date: 2022-01-12 10:45:52
 * @LastEditTime: 2022-01-12 14:20:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\store\actionCreators.js
 */
import { earePage } from "../api";
import { GET_EARID } from "./constants";
export const requestAction = (dispatch, getState) => {
  earePage({ pageSize: 100, pageNum: 1 }).then((res) => {
    if (res.code === 200) {
      let list = res.data.map((v) => {
        return {
          name: v.earName === "莎湾院" ? "运达院" : v.earName,
          id: v.id,
          ref: `/linkMap/${v.id}`,
          phone: v.earTel,
          address: v.addr,
          point: `${v.longitude}|${v.latitude}`,
          isOpen: 1,
          icon: { w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12 },
          content: `电话：${v.earTel}<br/>${v.addr}`,
          line: () => {
            return (
              <h2>
                <p>
                  <b>公&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;交：</b>
                  <span style={{ whiteSpace: "pre-wrap" }}>{v.busRoad}</span>
                </p>
                <p>
                  <b>自驾/的士：</b>
                  <span>{v.carRoad}</span>
                </p>
                {v.metroRoad ? (
                  <p>
                    <b>
                      地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;铁：
                    </b>
                    <span>{v.metroRoad}</span>
                  </p>
                ) : null}
              </h2>
            );
          },
        };
      });

      dispatch(getEarList(list.filter((v) => v.id !== 9)));
    }
  });
};

export const getEarList = (earList) => {
  return {
    type: GET_EARID,
    earList: earList,
  };
};
